import { ColumnasModalAlertaFE, rutaMonitorFacturacionElectronica } from 'app/vistas/Acciones/FE-noAutorizados/fe.helper'
import DataTableFilterDemo from 'components/Datatable'
import moment from 'moment'
import React from 'react'
import { Button, Modal, ModalProps } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'

interface ModalAlertaFEProps extends ModalProps {
    facturas: any[]
}
export default function ModalAlertaFacturaElectronica(props: ModalAlertaFEProps) {
    const history = useHistory()

    const formatearFacturas = () => {
        return props.facturas.map(factura => ({...factura,
            factura: `${factura.prefijo}${factura.consecutivo}`,
            fecha: moment(factura.fecha).format('DD/MM/YYYY h:mm A')
        }))
    }

    const handleIrAlMonitor = () => {
        const params = new URLSearchParams()
        params.append('tab', 'RES')
        history.push(`${rutaMonitorFacturacionElectronica}?${params.toString()}`)
        if (props.onHide) {
            props.onHide()
        }
    }

    return (
        <Modal {...props}>
            <Modal.Header placeholder='' closeButton>
                <Modal.Title>FACTURAS SIN GESTIONAR</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ marginBottom: '8px', fontSize: '12px', color: 'red' }}>
                    * Solo se podrán visualizar facturas que sobrepasen el número de intentos parametrizado.
                </p>
                <DataTableFilterDemo data={formatearFacturas()} columns={ColumnasModalAlertaFE} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='primary' onClick={handleIrAlMonitor}>Ir al monitor</Button>
            </Modal.Footer>
        </Modal>
    )
}